<script setup>
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const props = defineProps({
    offersUnavailable: {
      type: Array,
      required: true
    },
    onlyOfferDeleted: {
      type: Array,
      required: false
    },
    automaticOfferReplacementAndRemoval: {
      type: Boolean,
      required: true,
      default: false
    }
  });
  const emits = defineEmits(['selectOffersUnavailable']);
  const showAllOffers = ref(false);
  const maxOffers = 10;
  const showButtonTitle = computed(() => {
    if(showAllOffers.value) {
      return t('cart.unavailable_offers.show_less');
    }
    return t('cart.unavailable_offers.show_more');
  });

  const handleToogleShowAllOffers = () => {
    showAllOffers.value = !showAllOffers.value;
  };

  const offersDisplayed = computed(() => {
    if(showAllOffers.value) {
      return !props.automaticOfferReplacementAndRemoval ? props.offersUnavailable : props.onlyOfferDeleted;
    }
    if (!props.automaticOfferReplacementAndRemoval) return props.offersUnavailable.slice(0, maxOffers);
    return props.onlyOfferDeleted.slice(0, maxOffers);
  });
</script>

<template>
  <div class="alert alert-danger mt-3 mb-0 pb-0" role="status" v-if="props.offersUnavailable.length > 0 || props.onlyOfferDeleted.length > 0">
    <slot name="header"></slot>
    <ul class="mb-2">
      <li v-for="offer in offersDisplayed" :key="offer.id">
        {{ offer.publication.title }}
      </li>
    </ul>
    <button class="btn btn-sm btn-outline-danger my-1 ms-0" v-if="offersUnavailable.length > maxOffers" @click.prevent="handleToogleShowAllOffers">
      {{ showButtonTitle }}
    </button>
    <slot name="footer"></slot>
    <button @click.prevent="emits('selectOffersUnavailable');" v-if="!props.automaticOfferReplacementAndRemoval" type="button" name="button" class="btn btn-danger mb-3 ms-0">
      {{ t('cart.unavailable_offers.delete_offers') }}
    </button>
  </div>
</template>

<style scoped>

</style>
